import { h, render, Fragment } from 'preact';
import { createPortal } from 'preact/compat';
import { useState } from 'preact/hooks';
import classnames from 'classnames';

const plans = [
  require('../content/subscription-plans/1.json'),
  require('../content/subscription-plans/2.json'),
  require('../content/subscription-plans/3.json'),
];

const PaymentModal = ({ isOpen, onClose, paymentLink }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <div class="payment-modal-backdrop" onClick={handleBackdropClick}>
      <div class="payment-modal">
        <button class="payment-modal-close" onClick={onClose} aria-label="Close">
          &times;
        </button>
        <div class="payment-modal-content">
          <p>After completing the payment, please share your Payment ID with <strong>@Richardily</strong> on Telegram</p>
          <a href={paymentLink} class="payment-modal-proceed" target="_blank" rel="noopener noreferrer">
            PROCEED
          </a>
        </div>
      </div>
    </div>,
    document.body
  );
};

const Plan = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div class="col-md-4">
      <div class={classnames('price-box', { 'price-active': props.styleType === 'Red' })}>
        <div class="discount">
          {props.badge && (
            <p><span>{props.badge}</span></p>
          )}
        </div>
        <div class="price-head">
            <h4>{props.title}</h4>
            <span>{props.isMostPopular && 'MOST POPULAR'}</span>
            <h3>{`$${props.price}`.replace(' ', '')}</h3>
            <p>{props.period}</p>
        </div>
        <div class="price-body">
          <ul>
            {props.points.map((point, idx) => (
              <li key={idx}>{point}</li>
            ))}
          </ul>
          <button onClick={() => setIsModalOpen(true)}>
            join <br/> now
          </button>
        </div>
      </div>
      <PaymentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        paymentLink={props.paymentLink}
      />
    </div>
  );
};

const Plans = () => {
  return (
    <>
      {plans.map((plan) => (
        <Plan
          key={plan.id}
          title={plan.title}
          price={plan.price}
          styleType={plan.styleType}
          period={plan.period}
          coinpaymentsCode={plan.coinpaymentsCode}
          isMostPopular={plan.isMostPopular}
          badge={plan.badge}
          points={plan.descriptionList}
          paymentLink={plan.paymentLink}
        />
      ))}
    </>
  );
}

render(<Plans />, document.getElementById('plans'))
